import validator from 'validator';

const validateuploadExcel = (data) => {
  let errors = {}

  const {file,category} = data;
  if(validator.isEmpty(file)) {
    errors.file =  "Excel 형식의 파일을 업로드 해주세요";
  }
  if(validator.isEmpty(category)) {
    errors.category =  "Please select Excel Category";
  }
 
 
  return {
    isInvalid: Object.keys(errors).length > 0,
    error: errors
  }
}

export default validateuploadExcel;